export function OracleManagementPage() {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold">Oracle Management</h1>
      <p className="text-muted-foreground">Configure and monitor price oracles.</p>
    </div>
  );
}
